<template>
    <auth-layout class="not-found-page">
        <div class="centered">
            <h1><img src="static/img/koala.png" width="300"/></h1>
            <p class="text-center">{{$t('disculpeLasMolestiasEstamosDeMantenimiento')}}</p>
        <p class="text-center"><a href="./">{{$t('vuelvaAIntentarloMasTarde')}}</a></p>
        </div>
    </auth-layout>
</template>

<script>
    import AuthLayout from './AuthLayout.vue'

    export default {
        components: {
            AuthLayout
        }
    }
</script>
<style lang="scss">
    .not-found-page {
        .full-page > .content,
        .centered {
            min-height: calc(100vh - 160px);
        }
        .not-found-icon {
            margin-right: 10px;
        }
        .centered {
            h1, i {
                font-size: 50px;
            }
            p {
                font-size: 20px;
            }
            display: flex;
            padding-bottom: 150px;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: white;
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/GeneralViews/ServerDown.vue